import styled from 'styled-components';
import theme from 'theme';

export const WhiteCard = styled.div`
  border-radius: ${theme.shape.borderRadius}px;
  border: 1px solid ${theme.palette.divider};
  padding: ${theme.padding.section};
  background: ${theme.palette.primary.white};
  position: relative;
  margin: ${theme.padding.content} 0;

  &.overdue::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background-color: ${theme.palette.error.main};
    border-top-left-radius: ${theme.radius.card};
    border-bottom-left-radius: ${theme.radius.card};
  }
  &.incoming::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background-color: ${theme.palette.warning.main};
    border-top-left-radius: ${theme.radius.card}; /* Match the border radius */
    border-bottom-left-radius: ${theme.radius.card}; /* Match the border radius */
  }
  &.button {
    cursor: pointer;
    &:hover {
      background-color: ${theme.palette.action.hover};
    }
  }
  &.active {
    border: 2px solid ${theme.palette.primary.main};
    padding: calc(${theme.padding.section} - 1px);
  }
`;

export const TransparentCard = styled.div`
  border-radius: ${theme.radius.card};
  padding: ${theme.padding.content};
  background: transparent;
`;


